import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Divider from "../Divider";

const SummarySimpleItemOrSubtotalContainer = ({
    additionalLabelContent = "",
    label = "",
    subtotal = "",
    isCms = false,
    hasDivider = false,
    isBold = false,
    isPromo = false,
    bottomMargin = "",
    topMargin = "",
}) => (
    <>
        {hasDivider && (
            <Divider
                classNames={cx(isCms ? "" : "registration-summary__divider")}
            />
        )}

        <div
            className={cx(
                "col col--12 col--no-gutter",
                bottomMargin && `-margin-bottom--${bottomMargin}`,
                topMargin && `-margin-top--${topMargin}`,
            )}
        >
            {label && subtotal && (
                // eslint-disable-next-line tailwindcss/classnames-order
                <div className="grid grid--no-gutters">
                    {" "}
                    <div className={cx("col col--8")}>
                        <small className={cx(isBold && "-font-weight--bold")}>
                            {label}
                            {additionalLabelContent && (
                                <>
                                    <span className="-margin-left--10 -margin-right--10">
                                        •
                                    </span>
                                    {additionalLabelContent}
                                </>
                            )}
                        </small>
                    </div>
                    <div className="col col--4 -text--right">
                        <small>
                            <span
                                className={cx(
                                    isBold && "-font-weight--bold",
                                    isPromo && "-text-decoration--line-through",
                                )}
                            >
                                {subtotal}
                            </span>
                        </small>
                    </div>
                </div>
            )}
        </div>
    </>
);
SummarySimpleItemOrSubtotalContainer.propTypes = {
    additionalLabelContent: PropTypes.string,
    label: PropTypes.string,
    subtotal: PropTypes.string,
    isCms: PropTypes.bool,
    hasDivider: PropTypes.bool,
    isBold: PropTypes.bool,
    isPromo: PropTypes.bool,
    bottomMargin: PropTypes.string,
    topMargin: PropTypes.string,
};

export default SummarySimpleItemOrSubtotalContainer;
